import { makeStyles } from '@rbx/ui';

const useFilterBarStyles = makeStyles()(() => ({
  autocomplete: {
    flex: '1 1 auto',
    minWidth: '300px',
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'wrap',
      minHeight: '40px',
    },
    '& .MuiAutocomplete-tag': {
      margin: '4px',
    },
  },
  groupHeader: {
    padding: '12px',
  },
  groupItems: {
    padding: 0,
    margin: 0,
    listStyle: 'none',
  },
}));

export default useFilterBarStyles;
